const INITIAL_STATE = {
  isLoading: true,
}

const state = () => INITIAL_STATE

const mutations = {
  setIsLoading (state, isLoading) {
    state.isLoading = isLoading
  },
}

const actions = {
  async fetchFromGivingService (_, { method, url, data, params }) {
    console.log(process.env.GIVING_API_URL)
    const givingApi = this.$axios.create({
      baseURL: process.env.GIVING_API_URL,
      headers: {
        'Content-Type': 'application/json',
      },
    })
    try {
      const response = await givingApi.request({
        method,
        url,
        data,
        params,
      })
      console.log('response')
      console.log(response)
      return response.data
    } catch (err) {
      console.log('Giving API error', err)
      throw err
    }
  },
  async authorizeEddaCreation ({ commit, dispatch, rootState }, applicantBankCode) {
    try {
      commit('setIsLoading', true)
      const data = await dispatch('fetchFromGivingService',
        {
          method: 'POST',
          url: 'e-giro/authorize/creation',
          data: {
            clientID: process.env.DBS_CLIENT_ID,
            applicantBankCode,
          },
        },
      )
      console.log(data)
      commit('setIsLoading', false)
      return data
    } catch (e) {
      dispatch('toast/error', 'Failed to authorize EDDA creation.', {
        root: true,
      })
    }
  },
  async boRedirectionCreation ({ commit, dispatch, rootState }, query) {
    try {
      commit('setIsLoading', true)
      const data = await dispatch('fetchFromGivingService',
        {
          method: 'POST',
          url: 'e-giro/bo-redirection',
          data: query,
        })
      commit('setIsLoading', false)
      return data
    } catch (e) {
      dispatch('toast/error', 'Failed to authorize EDDA creation.', {
        root: true,
      })
    }
  },
  async authorizeCancellationRedirection ({ commit, dispatch, rootState }, record) {
    try {
      commit('setIsLoading', true)
      const data = await dispatch('fetchFromGivingService', {
        method: 'POST',
        url: 'e-giro/authorize/cancellation',
        data: {
          clientID: process.env.DBS_CLIENT_ID,
          applicantBankCode: record.applicantBankCode,
          boDDARefNo: record.boDdaRefNo,
          boTransactionRefNo: record.boTransactionRefNo,
        },
      })
      commit('setIsLoading', false)
      return data
    } catch (e) {
      dispatch('toast/error', 'Failed to authorize EDDA creation.', {
        root: true,
      })
    }
  },
  async boRedirectionCancellation ({ commit, dispatch, rootState }, query) {
    try {
      commit('setIsLoading', true)
      const data = await dispatch('fetchFromGivingService', {
        method: 'POST',
        url: 'e-giro/bo-redirection/cancel',
        data: query,
      })
      commit('setIsLoading', false)
      return data
    } catch (e) {
      dispatch('toast/error', 'Failed to authorize EDDA creation.', {
        root: true,
      })
    }
  },
  async getAllExistingEdda ({ commit, dispatch, rootState }) {
    try {
      commit('setIsLoading', true)
      const data = await dispatch('fetchFromGivingService', {
        method: 'GET',
        url: 'e-giro/existing-edda',
      })
      commit('setIsLoading', false)
      return data
    } catch (e) {
      dispatch('toast/error', 'Failed to authorize EDDA creation.', {
        root: true,
      })
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
